module.exports = __webpack_public_path__ + "img/cp-search.9538aa2c.svg";